import ApplyEmploymentScreen from 'features/lineOfCredit/screens/applyEmployment/ApplyEmploymentScreen';
import React from 'react';

export default function Page() {
  return <ApplyEmploymentScreen />;
}
